import React from 'react'

const Careers = () => (
  <div>
    <h1>Careers</h1>
  </div>
)

export default Careers


// WEBPACK FOOTER //
// ./src/pages/careers.js